import { render, staticRenderFns } from "./MenuTree.vue?vue&type=template&id=7b66ad70&"
import script from "./MenuTree.vue?vue&type=script&lang=js&"
export * from "./MenuTree.vue?vue&type=script&lang=js&"
import style0 from "./MenuTree.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports